import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  Box,
  Button,
} from '@chakra-ui/react';
import { DeferredDocument } from 'types/documents';

interface ResolveDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  document: DeferredDocument | null;
  isProcessing: boolean;
  onConfirm: () => void;
}

const ResolveDocumentModal = ({
  isOpen,
  onClose,
  document,
  isProcessing,
  onConfirm,
}: ResolveDocumentModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Mark Document as Resolved</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>
              Are you sure you want to mark this document as resolved?
            </Text>
            <Box bg="gray.50" p={4} borderRadius="md">
              <Text fontWeight="600" color="secondaryGray.900">
                {document?.text}
              </Text>
              <Text fontSize="sm" color="gray.600" mt={2}>
                This document will be removed from the active pending list and
                will positively impact the document score.
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="green"
            onClick={onConfirm}
            isLoading={isProcessing}
          >
            Mark as Resolved
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ResolveDocumentModal;
